import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface GetInspectParsingJobParameter {
  jobId: string;
}

export interface GetInspectParsingJobRequest {}

export interface InspectParsingJobResultConditions {
  [productId: string]: {
    by: "MARKUP" | "DISCOUNT";
    value: number;
    applyIva: boolean | null;
  };
}

export interface InspectParsingJobResult {
  conditions?: InspectParsingJobResultConditions;
  [key: string]: any;
}

export interface GetInspectParsingJobResponse {
  jobId: string;
  status: string;
  lssId?: number;
  totalProducts?: number;
  createdAt?: string;
  updatedAt?: string;
  result?: InspectParsingJobResult | null;
  error?: string | null;
}

export const getInspectParsingJobTemplateUrl =
  "/inspect-parsing-jobs/:jobId";

export const getInspectParsingJobKey: YWRKey<GetInspectParsingJobParameter> = {
  url: (parameter) => calcUrl(getInspectParsingJobTemplateUrl, parameter),
  method: "get",
};

export default function useGetInspectParsingJob() {
  const fetcher = useFetcher<
    GetInspectParsingJobRequest,
    GetInspectParsingJobResponse
  >();
  return useYWR(getInspectParsingJobKey, fetcher);
}
